// 资质宝-各资质类型材料维护板块
import request from '@/utils/request'

// 房地产开发材料记录查询
export const getRealtyKfMaterialRecordGetById = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/realtyKfMaterialRecord/getMaterialRecord',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 房地产开发材料记录保存
export const realtyKfMaterialRecordSaveOrUpdate = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/realtyKfMaterialRecord/saveOrUpdate',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 获取人员库（专业管理人员信息）
export const getRealtyKfRyPagerList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/realtyKfRy/pager',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 房地产开发人员表新增与修改
export const realtyKfRySaveOrUpdate = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/realtyKfRy/saveOrUpdate',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 房地产开发人员表删除
export const removeById = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/realtyKfRy/removeById',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
